import { useId, useState, useSyncExternalStore, type ReactNode } from "react";
import { SlidersHorizontal } from "lucide-react";
import { BottomSheet } from "./BottomSheet";
import { Button } from "./Button";

const subscribe = (notify: () => void) => { const media = window.matchMedia("(min-width: 1024px)"); media.addEventListener("change", notify); return () => media.removeEventListener("change", notify); };
/** One controlled form: inline on laptop, in a sheet on phones; no duplicate hidden inputs. */
export function ResponsiveFilters({ search, summary, title, children, onReset }: { search: ReactNode; summary: string; title: string; children: ReactNode; onReset: () => void }) {
  const laptop = useSyncExternalStore(subscribe, () => window.matchMedia("(min-width: 1024px)").matches, () => false);
  const [open, setOpen] = useState(false);
  const triggerId = useId();
  const close = () => setOpen(false);
  const fields = <div className="v365-filter-fields">{children}</div>;
  return <div className="v365-filter-bar">
    <div className="v365-filter-search">{search}{!laptop && <Button id={triggerId} variant="secondary" fullWidth={false} icon={<SlidersHorizontal aria-hidden size={18} />} onClick={() => setOpen(true)}>Filters</Button>}<Button variant="secondary" fullWidth={false} onClick={onReset}>Reset</Button></div>
    {laptop ? fields : <BottomSheet open={open} onClose={close} returnFocusId={triggerId} title={title} footer={<Button onClick={close}>Done</Button>}>{fields}</BottomSheet>}
    <p className="v365-filter-summary">{summary}</p>
  </div>;
}
